import { useSelector } from 'react-redux'
import { useAlertActions } from '../store/slices/AlertSlice'

const useAlert = () => {
    const open = useSelector(state => state.AlertSlice?.open || false)
    const message = useSelector(state => state.AlertSlice?.alert?.message)
    const title = useSelector(state => state.AlertSlice?.alert?.title)
    const type = useSelector(state => state.AlertSlice?.alert?.type)
    const onDone = useSelector(state => state.AlertSlice?.alert?.onDone)
    const textOk = useSelector(state => state.AlertSlice?.alert?.textOk)
    const onCancel = useSelector(state => state.AlertSlice?.alert?.onCancel)
    const textCancel = useSelector(state => state.AlertSlice?.alert?.textCancel)

    const { handleChangeAlert, handleChangeOpen } = useAlertActions()

    return {
        handleChangeAlert,
        handleChangeOpen,
        open,
        message,
        title,
        type,
        onDone,
        textOk,
        onCancel,
        textCancel,
    }
}

export default useAlert
